// extracted by mini-css-extract-plugin
export default {"container":"PreviewTemplate_container__c-BMj","edit":"PreviewTemplate_edit__qwN71","fixedHeight":"PreviewTemplate_fixedHeight__YZ-JM"};